import React, { ReactElement } from "react";

interface Props {
  backGroundColor: string;
  fontColor: string;
}

function Icon({ backGroundColor, fontColor }: Props): ReactElement {
  return (
    <svg
      version="1.1"
      id="Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 200 200"
    >
      <g transform="matrix( 1, 0, 0, 1, 0,0) ">
        <g>
          <g id="Layer0_0_FILL">
            <path
              fill={backGroundColor ? backGroundColor : "white"}
              d="M179.5,39.4c-2.7-3.6-5.7-7-8.9-10.2c-3.2-3.2-6.6-6.2-10.1-8.9c-3.6-2.8-7.5-5.3-11.6-7.6
				c-4.1-2.3-8.4-4.4-13-6.2c-4.6-1.8-9.5-3.3-14.8-4.4C116,1.1,110.4,0.3,104.3,0c0,0-0.1,0-0.2,0c-2.8,0-5.6,0-8.5,0
				c0,0.1-0.1,0.2-0.3,0.2c-6.1,0.2-11.8,0.9-17,2.1c-5.2,1.2-10,2.7-14.6,4.4c-4.6,1.8-8.9,3.8-13,6.2c-4,2.3-7.9,4.8-11.5,7.6
				c-3.6,2.7-7,5.7-10.1,8.9c-2.6,2.6-5.1,5.3-7.4,8.2c-0.5,0.6-1,1.3-1.5,1.9c-2.8,3.6-5.3,7.4-7.6,11.5c-2.3,4.1-4.4,8.4-6.1,13
				c-1.8,4.6-3.2,9.5-4.4,14.7C1.1,84,0.3,89.7,0,95.7c0,2.9,0,5.7,0,8.6c0,0,0,0.1,0,0.1c0.3,6,1.1,11.7,2.2,16.8
				c1.1,5.3,2.6,10.2,4.3,14.8c1.8,4.6,3.9,8.9,6.2,13c2.3,4.1,4.8,8,7.6,11.6c0.5,0.7,1,1.3,1.5,1.9c2.3,2.9,4.8,5.6,7.4,8.2
				c3.2,3.2,6.6,6.1,10.2,8.9c3.6,2.8,7.4,5.3,11.5,7.6c4.1,2.4,8.4,4.4,13,6.2c4.5,1.8,9.4,3.3,14.6,4.4c5.1,1.1,10.6,1.9,16.5,2.2
				c3.4,0,6.7,0,10,0h0.1v-0.1c6.1-0.3,11.8-1,16.9-2.1c5.2-1.2,10.1-2.7,14.7-4.4c4.6-1.8,8.9-3.9,12.9-6.2
				c4.1-2.3,7.9-4.9,11.5-7.7c3.6-2.8,6.9-5.8,10.1-8.9c3.2-3.2,6.1-6.6,8.9-10.2s5.2-7.5,7.4-11.6c2.3-4.1,4.3-8.4,6.1-12.9
				c1.8-4.6,3.2-9.6,4.3-14.8c1.1-4.9,1.8-10.2,2.1-15.8c0,0,0-0.1,0-0.2c0-3.3,0-6.6,0-10c-0.4-5.9-1.1-11.4-2.2-16.5
				c-1.1-5.2-2.6-10.1-4.4-14.6c-1.8-4.6-3.9-8.9-6.2-13C184.8,46.8,182.3,43,179.5,39.4 M156.2,42.1L156.2,42.1
				c-3.1,3.4-6.1,6.7-9.2,10c-3,3.3-6.1,6.6-9.2,9.9c-3.1,3.3-6.1,6.6-9.2,9.9s-6.1,6.6-9.2,9.9c-2.6,2.9-5.3,5.8-7.9,8.7
				c2.7,3.7,5.4,7.3,8.2,11c2.7,3.7,5.5,7.3,8.2,10.9c2.7,3.7,5.4,7.3,8.2,11c2.7,3.7,5.4,7.3,8.1,10.9c2.7,3.6,5.5,7.3,8.2,10.9
				c2.7,3.6,5.5,7.3,8.2,10.9c0.4,0.6,0.9,1.1,1.3,1.7c-0.6,0.3-1.3,0.4-2.2,0.4c-6.4-0.1-12.7-0.1-19.1-0.1c-5.2,0-10.4,0-15.6,0
				c-2.7-3.6-5.5-7.3-8.2-10.9c-2.7-3.7-5.5-7.3-8.2-11c-2.7-3.6-5.5-7.3-8.2-10.9s-5.5-7.3-8.2-10.9c-0.4-0.5-0.8-1.1-1.2-1.8
				c-3.1,3.3-6.1,6.6-9.2,9.9c-3.1,3.3-6.1,6.6-9.2,9.9s-6.1,6.6-9.2,9.9c-3.1,3.3-6.1,6.6-9.2,9.9c-1.8,1.9-3.5,3.9-5.2,5.8
				c-3.7,0-7.4,0-11-0.1v-0.1c3.1-3.3,6.1-6.6,9.2-9.9c3.1-3.3,6.1-6.6,9.2-9.9s6.1-6.6,9.2-9.9c3-3.3,6.1-6.6,9.2-9.9
				c3.1-3.3,6.1-6.7,9.2-10c0.7-0.8,1.4-1.5,2.1-2.3c-2.7-3.7-5.4-7.3-8.2-11c-2.7-3.6-5.4-7.3-8.1-10.9c-2.7-3.6-5.5-7.3-8.2-10.9
				c-2.7-3.6-5.5-7.3-8.1-11c-2.7-3.7-5.4-7.3-8.1-11c-2.3-3.1-4.6-6.1-6.9-9.1c0.6-0.2,1.3-0.3,2.2-0.3c6.4,0.1,12.7,0.1,19.1,0.1
				c5.2,0,10.4,0,15.6,0c2.7,3.7,5.4,7.3,8.1,11c2.7,3.6,5.5,7.3,8.2,10.9c2.7,3.6,5.5,7.3,8.2,10.9c2.2,3,4.5,6,6.8,9
				c3.1-3.2,6.2-6.5,9.2-9.8c3.1-3.3,6.1-6.6,9.2-9.9c3.1-3.3,6.1-6.6,9.2-9.9c3-3.3,6.1-6.6,9.1-9.9c0.7-0.7,1.3-1.5,1.9-2.2
				C149,42.1,152.6,42.1,156.2,42.1 M103.9,93.9c-2.7-3.6-5.5-7.3-8.2-10.9c-2.7-3.6-5.4-7.3-8.1-10.9c-2.7-3.7-5.4-7.3-8.2-11
				c-2.7-3.6-5.5-7.3-8.2-10.9c-0.1,0-0.1,0-0.2,0c-5.5,0-11.1,0-16.7,0c0.4,0.5,0.7,1,1.1,1.5c2.8,3.6,5.5,7.3,8.2,10.9
				c2.7,3.6,5.5,7.3,8.2,10.9c2.7,3.7,5.5,7.3,8.2,10.9c2.7,3.6,5.4,7.3,8.2,11c2.7,3.7,5.4,7.3,8.1,10.9c2.8,3.7,5.5,7.3,8.2,10.9
				c2.7,3.6,5.5,7.3,8.2,10.9c2.7,3.6,5.5,7.3,8.2,11c2.7,3.6,5.4,7.3,8.1,10.9c0,0,0.1,0,0.1,0c5.6,0.1,11.1,0,16.6-0.1
				c-0.4-0.5-0.7-1-1.1-1.4c-2.7-3.6-5.4-7.3-8.2-10.9c-2.7-3.6-5.4-7.3-8.1-10.9c-2.7-3.7-5.4-7.3-8.1-11
				c-2.7-3.6-5.5-7.3-8.2-10.9C109.4,101.2,106.7,97.5,103.9,93.9z"
            />
            <path
              fill={fontColor ? fontColor : "white"}
              d="M156.2,42.2L156.2,42.2c-3.6-0.1-7.3-0.1-10.9-0.1c-0.6,0.8-1.2,1.5-1.9,2.2c-3.1,3.3-6.1,6.6-9.1,9.9
				c-3.1,3.3-6.1,6.6-9.2,9.9c-3.1,3.3-6.1,6.6-9.2,9.9c-3.1,3.3-6.1,6.6-9.2,9.8c-2.3-3-4.5-6-6.8-9c-2.7-3.6-5.5-7.3-8.2-10.9
				c-2.7-3.6-5.5-7.3-8.2-10.9c-2.7-3.6-5.4-7.3-8.1-11c-5.2,0-10.3,0-15.6,0c-6.4,0-12.7,0-19.1-0.1c-0.9,0-1.7,0.1-2.2,0.3
				c2.3,3,4.6,6,6.9,9.1c2.7,3.6,5.4,7.3,8.1,11c2.7,3.7,5.4,7.3,8.1,11c2.7,3.6,5.5,7.3,8.2,10.9c2.7,3.6,5.4,7.3,8.1,10.9
				c2.7,3.7,5.5,7.3,8.2,11c-0.7,0.8-1.4,1.5-2.1,2.3c-3,3.3-6.1,6.6-9.2,10c-3.1,3.3-6.1,6.6-9.2,9.9c-3.1,3.3-6.1,6.6-9.2,9.9
				s-6.1,6.6-9.2,9.9c-3.1,3.3-6.1,6.6-9.2,9.9v0.1c3.6,0,7.3,0.1,11,0.1c1.7-1.9,3.5-3.9,5.2-5.8c3.1-3.3,6.1-6.6,9.2-9.9
				c3.1-3.3,6.1-6.6,9.2-9.9s6.1-6.6,9.2-9.9c3-3.3,6.1-6.6,9.2-9.9c0.3,0.7,0.7,1.3,1.2,1.8c2.8,3.6,5.5,7.3,8.2,10.9
				s5.5,7.3,8.2,10.9c2.7,3.6,5.5,7.3,8.2,11c2.7,3.6,5.4,7.3,8.2,10.9c5.2,0,10.4,0,15.6,0c6.4,0,12.7,0,19.1,0.1
				c0.9,0,1.7-0.1,2.2-0.4c-0.5-0.6-0.9-1.1-1.3-1.7c-2.7-3.6-5.5-7.3-8.2-10.9c-2.7-3.6-5.5-7.3-8.2-10.9
				c-2.7-3.6-5.4-7.3-8.1-10.9c-2.7-3.6-5.5-7.3-8.2-11c-2.7-3.6-5.4-7.3-8.2-10.9c-2.7-3.6-5.5-7.3-8.2-11c2.6-2.9,5.3-5.8,7.9-8.7
				c3.1-3.3,6.1-6.6,9.2-9.9s6.1-6.6,9.2-9.9c3.1-3.3,6.1-6.6,9.2-9.9C150.1,48.8,153.2,45.5,156.2,42.2 M95.8,83
				c2.7,3.6,5.5,7.3,8.2,10.9c2.7,3.7,5.4,7.3,8.2,11c2.7,3.6,5.5,7.3,8.2,10.9c2.7,3.6,5.4,7.3,8.1,11c2.7,3.6,5.4,7.3,8.1,10.9
				c2.8,3.7,5.5,7.3,8.2,10.9c0.4,0.4,0.7,0.9,1.1,1.4c-5.4,0.1-10.9,0.2-16.6,0.1c0,0-0.1,0-0.1,0c-2.7-3.6-5.4-7.3-8.1-10.9
				c-2.7-3.7-5.5-7.3-8.2-11c-2.7-3.6-5.5-7.3-8.2-10.9c-2.7-3.6-5.4-7.3-8.2-10.9c-2.7-3.6-5.4-7.2-8.1-10.9
				c-2.7-3.7-5.4-7.3-8.2-11c-2.7-3.6-5.5-7.3-8.2-10.9c-2.7-3.6-5.5-7.3-8.2-10.9c-2.7-3.6-5.4-7.3-8.2-10.9
				c-0.4-0.5-0.7-1-1.1-1.5c5.6,0,11.1,0,16.7,0c0,0,0.1,0,0.2,0c2.7,3.6,5.5,7.3,8.2,10.9c2.7,3.6,5.4,7.3,8.2,11
				C90.3,75.7,93,79.3,95.8,83z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
